import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceForm from '../containers/ResourceFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resources_route_edit')} />
          <ResourceForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceEditScreen;

Logger.log('silly', `ResourceEditScreen loaded.`);
